import React from 'react';
import PropTypes from 'prop-types';
import {
  CardMedia,
  Typography,
  CardTitle,
  CardActions
} from '@one-thd/sui-atomic-components';
import ProjectsHeader from '../ProjectsHeader';
import NullStateCreateProjectAction from './NullStateCreateProjectAction';
import nullStateConstants from '../../constants/nullStateConstants';

const MobileNullView = ({
  componentId
}) => {
  const {
    cardTitle,
    bodyText,
    imageAlt,
    imageUrl,
    buttonText,
  } = nullStateConstants;

  return (
    <div
      data-component="Projects"
      data-testid="projects-null-container"
      className="sui-flex sui-flex-col sui-gap-4"
    >
      <div
        className="sui-flex sui-flex-col sui-gap-1"
      >
        <ProjectsHeader
          actions={['learnMore']}
          componentId={componentId}
        />
        <CardMedia
          src={imageUrl}
          alt={imageAlt}
          aspect="wide"
        />
      </div>
      <div
        className="sui-flex sui-flex-col sui-justify-between sui-h-full"
      >
        <div className="sui-flex sui-flex-col sui-gap-2 sui-pb-4 sui-pt-1">
          <CardTitle
            headerVariant="h3"
            headerWeight="display"
            header={<span style={{ whiteSpace: 'pre-line' }}>{cardTitle}</span>}
          />
          <Typography variant="body-base">
            {bodyText}
          </Typography>
        </div>
        <div>
          <CardActions className="sui-w-full">
            <NullStateCreateProjectAction
              cacheKey="mobile-null-view-create-project"
              componentId={componentId}
              buttonText={buttonText}
            />
          </CardActions>
        </div>
      </div>
    </div>

  );
};

MobileNullView.propTypes = {
  componentId: PropTypes.string,
};
MobileNullView.defaultProps = {
  componentId: '',
};

export default MobileNullView;
